import { useState } from "react";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePassword() {
  const { checkAuth } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.new_password !== form.confirm) return setError("The new passwords do not match.");
    if (form.new_password.length < 8) return setError("Use at least 8 characters.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password, new_password: form.new_password,
      });
      await checkAuth();
      window.location.href = "/dashboard";
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFDFD] p-6" data-testid="change-password-page">
      <div className="w-full max-w-sm rounded-md border border-[#E5E7EB] bg-white p-8">
        <Logo />
        <KeyRound className="h-6 w-6 text-[#002FA7] mt-6" />
        <h1 className="font-heading text-xl font-bold text-[#111827] mt-3">Set your own password</h1>
        <p className="text-sm text-[#6B7280] mt-1">
          You signed in with a temporary password issued by your administrator. Choose a new one to continue.
        </p>
        <form onSubmit={submit} className="space-y-4 mt-6">
          {[["current_password", "Temporary password"], ["new_password", "New password"], ["confirm", "Confirm new password"]].map(([k, l]) => (
            <div key={k}>
              <Label className="text-xs uppercase tracking-[0.1em] text-[#6B7280]">{l}</Label>
              <Input type="password" value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                required data-testid={`cp-${k}`} className="mt-1.5" />
            </div>
          ))}
          {error && <p className="text-sm text-[#C92A2A]" data-testid="cp-error">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="cp-submit-btn" className="w-full bg-[#002FA7] hover:bg-[#00237C] text-white">
            {busy ? "Saving…" : "Save password and continue"}
          </Button>
        </form>
      </div>
    </div>
  );
}
